import React, { useState } from 'react';
import styled from 'styled-components';
import ReactBnbGallery from 'react-bnb-gallery';
import PropTypes from 'prop-types';
import Button from './button';
import Img from 'gatsby-image';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { StyledFestivalPrice } from '../components/styled-festival-price';
import { formatCurrency } from '../helpers/formatCurrency';
import GalleryIcon from '../../static/gallery-icon.svg';

const StyledProperty = styled.article`
  background: var(--c-white);
  width: 100%;
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  min-height: 40rem;
  border-radius: var(--border-radius);
  margin-bottom: var(--v-spacing);
`;

const StyledPropertyContent = styled.div`
  padding: 3rem;
`;

const StyledPropertyImage = styled.div`
  position: relative;
  width: 100%;
  max-height: 32rem;
  border-top-right-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
  overflow: hidden;
`;

const StyledPropertyGalleryButton = styled.button`
  all: unset;
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 4.4rem;
  background: var(--c-red);
  padding: 1rem;
  cursor: pointer;
`;

const Property = props => {
  const { name, images, sleeps, price, description } = props;
  const [galleryOpen, setGalleryOpen] = useState(false);
  const galleryImages = images.map(image => {
    return {
      photo: image.fixed.src,
    };
  });
  return (
    <StyledProperty>
      <StyledPropertyImage>
        <Img
          fluid={images[0].fluid}
          alt={`Interior shot of ${name}`}
          style={{
            height: '100%',
          }}
        />
        <StyledPropertyGalleryButton aria-label={`Show image gallery for ${name}`} onClick={() => setGalleryOpen(!galleryOpen)}>
          <img src={GalleryIcon} width="100%" alt="Created by Carly Sanker from the Noun Project" />
        </StyledPropertyGalleryButton>
      </StyledPropertyImage>
      <StyledPropertyContent>
        <h3>{name}</h3>
        {documentToReactComponents(description)}
        <p>
          Sleeps: <b>{sleeps}</b>
          <br />
          <StyledFestivalPrice>{formatCurrency.format(price)}</StyledFestivalPrice> per night
        </p>
        <Button text={'Book now!'} to={''} />
      </StyledPropertyContent>
      <ReactBnbGallery show={galleryOpen} photos={galleryImages} onClose={() => setGalleryOpen(!galleryOpen)} />
    </StyledProperty>
  );
};

export default Property;
